import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
// Routes 

// Components 


import LinearProgress from '@mui/material/LinearProgress';

// Icons 

import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

// import Dropdown from './Dropdown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { getDoctorLogs, getGroupAccessListWithGroupId, getGroupLogs } from '../../../../routes/hacker/users';
import GroupAccessRow from './GroupAccessRow';
import InfoRow from '../../../general/inputs/InfoRow';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SensorsOutlinedIcon from '@mui/icons-material/SensorsOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PublicIcon from '@mui/icons-material/Public';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import DataBox from '../../../general/data/DataBox';
import ForkRightIcon from '@mui/icons-material/ForkRight';
import getCapitalizedString from '../../../../util/style/getCapitalizedString';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import DataArrayIcon from '@mui/icons-material/DataArray';

const DoctorLogs: React.FC = () => {

    const { t } = useTranslation();
    
    const dispatch = useAppDispatch();

    const colors = useAppSelector(state => state.theme.colors);  
    const selectedDoctor = useAppSelector(state => state.doctorsAccess.selectedDoctor);  

    const [postionX, setPositionX] = useState(0); 
    const [positionY, setPositionY] = useState(0); 


    const [stopLoading, setStopLoading] = useState(false); 
    const [logsList, setLogsList] = useState([]); 

    // -- 

    const handleDoctorLogs = async () => { 

      const res = await getDoctorLogs(selectedDoctor?._id) as any; 

      if (res.data.status === 200) { 

        setLogsList(res.data.doctorLogs);  

        setStopLoading(true); 

      };

    }; 

    // -- 

    const handleSelection = (e: any, group: any) => { 

      setPositionX(e.pageX);
      setPositionY(e.pageY); 

    }; 

    // -- 

    useEffect(() => { 

        if (selectedDoctor) { 

            handleDoctorLogs(); 

        }; 

    },[selectedDoctor]); 

    // -- 
    
    return (

        <DataBox 
            title='Doctor Logs'
            extraStyle={{ 
                overflow: 'auto',
                marginTop: 2, 
                minHeight: 500, 
            }}
        >
        
            {logsList?.map((doctorLog: any, index: any) => { 

                let description = '' as any; 
                let descriptionIcon = null as any; 
                let icon = <AccountCircleIcon sx={{ color: colors?.main }} />;

                const doctorName = `${selectedDoctor?.firstName} ${selectedDoctor?.lastName}`; 

                if (doctorLog.type == 'login') { 
                    description = `${doctorName} logged into the SaaS.`; 
                    icon = (doctorLog.device == 'mobile') ? <PhoneIphoneOutlinedIcon sx={{ color: colors?.main }} /> : <PersonalVideoIcon sx={{  color: 'darkblue' }} />;
                    // icon = <SensorsOutlinedIcon sx={{ color: colors?.mainHover }} />
                } else if (doctorLog.type == 'createConsultation') { 
                    description = `${doctorName} created a new consultation.`; 
                    icon = <FolderSharedOutlinedIcon sx={{ color: 'rgb(194, 75, 20)' }} />
                } else if (doctorLog.type == 'createConsultationNote') { 
                    description = `${doctorName} created a new note.`; 
                    icon = <DescriptionOutlinedIcon sx={{ color: 'rgb(194, 20, 185)' }} />
                } else if (doctorLog.type == 'preferences') { 
                    description = `${doctorName} updated his account preferences.`; 
                    icon = <PublicIcon sx={{ color: 'rgb(20, 143, 13)' }} />
                } else if (doctorLog.type == 'checkoutSession') { 
                    description = `${doctorName} initiated a checkout session.`; 
                    icon = <ShoppingCartOutlinedIcon sx={{ color: 'rgb(153, 19, 194)' }} />
                } else if (doctorLog.type == 'navigation') { 
                    description = `${doctorName} navigated to -> ${getCapitalizedString(doctorLog?.page)}.`; 
                    icon = <ForkRightIcon sx={{ color: 'rgb(21, 155, 126)' }} />
                } else if (doctorLog.type == 'accountDeletion') { 
                    description = `${doctorName} deleted his account.`; 
                    icon = <HighlightOffIcon sx={{ color: 'rgb(163, 33, 10)26)' }} />
                } else if (doctorLog.type == 'accountBlocked') { 
                    description = `${doctorName}'s account has been blocked for spam prevention purposes.`; 
                    icon = <RemoveCircleOutlineIcon sx={{ color: 'rgb(148, 103, 56)' }} />
                } else if (doctorLog.type == 'loginAttempt') { 
                    description = `${doctorName}'s initiated a login attempt.`; 
                    icon = <DataArrayIcon sx={{ color: 'rgb(38, 148, 5)26)' }} />
                }; 
    
                return <InfoRow
                        key={index}
                        title={moment(doctorLog?.createdAt).utc(true).format('LLL')}
                        titleStyle={{ marginLeft: 0 }}
                        // icon={icon}
                        description={description}
                        descriptionIcon={icon}
                        descriptionStyle={{ fontSize: 14, color: 'rgb(130, 130, 130)'}}
                    />
                
            })}

            {((logsList?.length === 0) && !stopLoading) &&         
          
                <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-evenly', 
                height: '100%',
                width: '80%', 
            }}>

                <Box
                    sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>

                    <LinearProgress sx={{ width: 500, marginBottom: 10 }} /> 

                    <Box>Retrieving Doctor Logs...</Box>

                </Box>

            </Box>}

        </DataBox>
    
      );

};

export default DoctorLogs;